// extracted by mini-css-extract-plugin
module.exports = {"content":"DocumentUpLoader_content__1P-kc","button":"DocumentUpLoader_button__1SHxl"};